/* @ngInject */
function CustomerSegmentController ($scope, $rootScope, $q, $translate, CustomerSegmentsService, GeneralSettingsService, ToastService) {
  $scope.flags = {
    loading: false
  }
  $scope.company = null
  $scope.businessSizeOptions = [
    {
      value: 'LOW',
      label: $translate.instant('businessSizeOptions.low')
    },
    {
      value: 'MID',
      label: $translate.instant('businessSizeOptions.mid')
    },
    {
      value: 'ENTERPRISE',
      label: $translate.instant('businessSizeOptions.enterprise')
    }
  ]
  $scope.companyBusinessModelOptions = []
  $scope.companyBusinessSegmentOptions = []
  $scope.companyBusinessActivityOptions = []
  $scope.businessModelInitialValue = null
  $scope.businessSegmentInitialValue = null
  $scope.businessActivityInitialValue = null
  $scope.businessSizeInitialValue = null

  const api = {
    _handleGetBusinessModels,
    _handleGetBusinessSegments,
    _handleBusinessActivitiesBySegment,
    _getBusinessActivitiesBySegment,
    _setInitialValues
  }
  this.getApi = () => api

  activate()
  function activate () {
    Promise.all([
      $rootScope.getUserCompany(true),
      CustomerSegmentsService.getAllBusinessModelsWithTexts(),
      CustomerSegmentsService.getAllBusinessSegmentsWithTexts()
    ]).then(([userCompany, businessModels, businessSegments]) => {
      $scope.company = userCompany

      api._handleGetBusinessModels(businessModels)
      api._handleGetBusinessSegments(businessSegments)
      api._setInitialValues()
    })
  }

  function _handleGetBusinessModels (businessModels) {
    const { rows } = businessModels

    $scope.companyBusinessModelOptions = rows.reduce((arr, businessModel) => {
      if (businessModel.texts.length) {
        arr.push({
          label: businessModel?.texts[0]?.title,
          value: businessModel?.id
        })
      }

      return arr
    }, [])

    return $q.resolve()
  }

  function _handleGetBusinessSegments (businessSegments, setAsFieldInitialValue = false) {
    const { rows } = businessSegments

    const mappedRows = rows.reduce((arr, businessSegment) => {
      if (businessSegment.texts.length) {
        arr.push({
          label: businessSegment?.texts[0]?.title,
          value: businessSegment?.id
        })
      }

      return arr
    }, [])

    if (setAsFieldInitialValue) {
      $scope.businessSegmentInitialValue = mappedRows[0]
    } else {
      $scope.companyBusinessSegmentOptions = mappedRows
    }

    return $q.resolve()
  }

  function _handleBusinessActivitiesBySegment (businessActivities) {
    const { rows } = businessActivities

    $scope.companyBusinessActivityOptions = rows.reduce((arr, businessActivity) => {
      if (businessActivity.texts.length) {
        arr.push({
          label: businessActivity?.texts[0]?.title,
          value: businessActivity?.id
        })
      }

      return arr
    }, [])

    return $q.resolve()
  }

  function _getBusinessActivitiesBySegment (businessSegmentId) {
    return CustomerSegmentsService.getAllBusinessActivitiesWithTextsBySegment(businessSegmentId)
      .then(api._handleBusinessActivitiesBySegment)
  }

  function _setInitialValues () {
    $scope.businessModelInitialValue = $scope.companyBusinessModelOptions.find(businessModel => businessModel.value === $scope.company?.businessModelId)
    $scope.businessSizeInitialValue = $scope.businessSizeOptions.find(businessSize => businessSize.value === $scope.company?.onboarding_business_size)

    if ($scope.company.businessActivityId) {
      CustomerSegmentsService.getBusinessSegmentByBusinessActivity($scope.company.businessActivityId)
        .then((response) => api._handleGetBusinessSegments(response, true))
        .then(() => api._getBusinessActivitiesBySegment($scope.businessSegmentInitialValue.value))
        .then(() => {
          $scope.businessActivityInitialValue = $scope.companyBusinessActivityOptions.find(businessActivity => businessActivity.value === $scope.company?.businessActivityId)
        })
    }
  }

  $scope.onChangeBusinessSegment = (event) => {
    const newValue = event?.detail?.value

    if (newValue) {
      $scope.company.businessSegmentId = newValue
      $scope.businessActivityInitialValue = null

      api._getBusinessActivitiesBySegment(newValue)
    }

    event.stopImmediatePropagation()
  }

  $scope.onChangeBusinessModel = (event) => {
    const newValue = event?.detail?.value

    if (newValue) {
      $scope.company.businessModelId = newValue
    }

    event.stopImmediatePropagation()
  }

  $scope.onChangeBusinessActivity = (event) => {
    const newValue = event?.detail?.value

    if (newValue) {
      $scope.company.businessActivityId = newValue
      $scope.businessActivityInitialValue = $scope.companyBusinessActivityOptions.find(businessActivity => businessActivity.value === newValue)
    }

    event.stopImmediatePropagation()
  }

  $scope.onChangeBusinessSize = (event) => {
    const newValue = event?.detail?.value

    if (newValue) {
      $scope.company.onboarding_business_size = newValue
    }

    event.stopImmediatePropagation()
  }

  $scope.saveCustomerSegment = async () => {
    $scope.flags.loading = true
    const userCompany = await $rootScope.getUserCompany(true)
    const data = {
      company: {
        ...userCompany,
        businessActivityId: $scope.company.businessActivityId,
        businessModelId: $scope.company.businessModelId
      }
    }

    try {
      await GeneralSettingsService.updateCompany(data)
      $scope.flags.loading = false
      ToastService.defaultSuccessToast()
    } catch (err) {
      console.error(err)
      ToastService.defaultErrorToast()
    } finally {
      const refreshedUserCompany = await $rootScope.getUserCompany(true)
      $scope.company = refreshedUserCompany
    }
  }

  $scope.resetCustomerSegment = () => {
    $scope.companyBusinessModelOptions = []
    $scope.companyBusinessSegmentOptions = []
    $scope.companyBusinessActivityOptions = []
    $scope.form = {
      businessModelId: null,
      businessSegmentId: null,
      businessActivityId: null
    }

    activate()
  }
}

export { CustomerSegmentController }
